import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drv-form-root drv-base-netradyne" }
const _hoisted_2 = { class: "row list-point-title" }
const _hoisted_3 = { class: "drv-ml-1 drv-text-body-md drv-text-weight-medium" }
const _hoisted_4 = { class: "row list-point-action" }
const _hoisted_5 = { class: "row list-point-title drv-mt-3" }
const _hoisted_6 = { class: "drv-ml-1 drv-text-body-md drv-text-weight-medium" }
const _hoisted_7 = { class: "row list-point-action" }

import { computed } from "vue";
import {
  ETelematicsMessagesKeys,
  IPlatform,
  IBaseConnectConfirm,
  EAuthTypes,
} from "../../../../types";
import { injector } from "@/services";
import { I18N_SERVICE_INJECTION_KEY } from "@/constants";
import HelpBtn from "@/modules/onboarding/components/blocks/telematics/HelpBtn.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NetradyneBasic',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit =
  __emit;

const i18n = injector.injectFromRoot(I18N_SERVICE_INJECTION_KEY);
const { t } = i18n.global;

const EMPTY_MODEL = {
  type: EAuthTypes.BASIC,
  agree: false,
};

const model = computed<IBaseConnectConfirm>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: IBaseConnectConfirm) {
    emit("update:modelValue", value);
  },
});

const agreeModel = computed<boolean>({
  get() {
    return props.modelValue?.agree ?? EMPTY_MODEL.agree;
  },
  set(value: boolean) {
    model.value = { ...model.value, agree: value };
  },
});

const hasError = computed<boolean>(() => {
  return !agreeModel.value;
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_checkbox = _resolveComponent("d-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "list-point-badge drv-bg-color-n100" }, "1", -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).NETRADYNE_POINT_1_TITLE)), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(HelpBtn, {
          link: _ctx.$t(_unref(ETelematicsMessagesKeys).NETRADYNE_INSTRUCTIONS_URL),
          label: _ctx.$t(_unref(ETelematicsMessagesKeys).NETRADYNE_POINT_1_BUTTON_TITLE),
          icon: "file",
          disable: _ctx.isLoading
        }, null, 8, ["link", "label", "disable"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "list-point-badge drv-bg-color-n100" }, "2", -1)),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).NETRADYNE_POINT_2_TITLE)), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_d_checkbox, {
          class: "drv-embeded-checkbox drv-form-control-adaptive",
          modelValue: agreeModel.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((agreeModel).value = $event)),
          disable: _ctx.disable,
          label: _ctx.$t(_unref(ETelematicsMessagesKeys).NETRADYNE_POINT_2_CHECKBOX_TITLE)
        }, null, 8, ["modelValue", "disable", "label"])
      ])
    ])
  ]))
}
}

})